var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"ok-variant":"ok","id":"front-page-modal","title":_vm.modal.title,"ok-only":""},on:{"ok":function($event){}}},[_c('p',{staticClass:"my-4",domProps:{"textContent":_vm._s(_vm.modal.body)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }